/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Add_Frame_To_StartInputs */



/**
* | output |
* | --- |
* | "Add 1 Frame To Start" |
*
* @param {Shortcut_Keys_Name_Add_Frame_To_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_add_frame_to_start = /** @type {((inputs?: Shortcut_Keys_Name_Add_Frame_To_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Add_Frame_To_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter 1 image au debut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge 1 Frame hinzu, um zu beginnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi 1 fotogramma all'inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить 1 кадр в начало")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir 1 fotograma para empezar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始时添加 1 帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始に1フレームを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरुआत में 1 फ्रेम जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicione 1 quadro ao início")
	return /** @type {LocalizedString} */ ("Add 1 Frame To Start")
});